import React from 'react';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH, registerGap2, pageEH3FontSize, mainPadd2 } from '../constraint/VendorConst';
import AdminMobileContentBox from './common/VendorMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import { requester } from "App";
import style from "./VendorMobileNoticeList.module.css"
import { useNavigate } from 'react-router-dom';


function VendorMobileNoticeList({ notices }) {

    const navigate = useNavigate();

    const moveDetailPage = (index) => {
        const notice = notices[index]; 
        console.log("전달할 공지 데이터:", notice);
        navigate('/vendor/main/notice/detail', { state: { notice } }); 
    };

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {/* 반복구간 */}
            {notices && notices.map((notice, index) => (
                <FlexChild key={index} height="initial">
                    <div className={style.noticeBox} onClick={() => moveDetailPage(index)}>
                        <AdminMobileContentBox flexStart>
                            <VerticalFlex gap={registerGap2}>
                                <FlexChild>
                                    <HorizontalFlex gap={registerGap2}>
                                        {/* <FlexChild width="auto">
                                    {notice.image ? (
                                        <img className={styles.noticeImg} src={notice.image} alt='공지사항 이미지' />
                                    ) : (
                                        <div>이미지 없음</div>
                                    )}
                                </FlexChild> */}
                                        <FlexChild>
                                            <VerticalFlex>
                                                <FlexChild>
                                                    <HorizontalFlex>
                                                        <FlexChild justifyContent={"center"}>
                                                            <P size={pageH1FontSize}>
                                                                {notice.title}
                                                            </P>
                                                        </FlexChild>
                                                        <FlexChild width="auto">
                                                            {/* {notice.status ? (
                                                        <>
                                                            {notice.status === "post" && (
                                                                <div className={styles.statusBox}>
                                                                    <P size={pageEH3FontSize}>게시</P>
                                                                </div>
                                                            )}
                                                            {notice.status === "end" && (
                                                                <div className={styles.statusEndBox}>
                                                                    <P size={pageEH3FontSize}>중지</P>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div>상태 없음</div>
                                                    )} */}
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                                <FlexChild alignItems="flex-start">
                                                    <HorizontalFlex gap={registerGap2}>
                                                        <FlexChild width="auto">
                                                            <P size={pageEH3FontSize}>
                                                                {notice.content ? notice.content : "내용 없음"}
                                                            </P>
                                                        </FlexChild>
                                                        {/* <FlexChild width="auto">
                                                    <P size={pageEH3FontSize}>~</P>
                                                </FlexChild>
                                                <FlexChild>
                                                    <P size={pageEH3FontSize}>
                                                        {notice.endDate ? notice.endDate : "종료 날짜 없음"}
                                                    </P>
                                                </FlexChild> */}
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex gap={registerGap2}>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={pageEH3FontSize}>노출 페이지</P>
                                                </FlexChild>
                                                <FlexChild justifyContent="flex-end">
                                                    <P size={pageEH3FontSize}>
                                                        {notice.displayPage ? notice.displayPage : 0} 페이지
                                                    </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={pageEH3FontSize}>노출 위치</P>
                                                </FlexChild>
                                                <FlexChild justifyContent="flex-end">
                                                    <P size={pageEH3FontSize}>
                                                        {notice.displayPosition ? notice.displayPosition : "위치 없음"}
                                                    </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </VerticalFlex>

                        </AdminMobileContentBox>
                    </div>
                </FlexChild>

            ))}
            {/* 반복구간 */}
        </VerticalFlex>
    )

}
export default VendorMobileNoticeList